module.exports = __webpack_public_path__ + "img/icon-explore.328117e0.svg";